package org.example.project.engineslot

import androidx.compose.runtime.Composable
import org.example.project.utils.All
import org.w3c.dom.events.MouseEvent
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div

@Composable
fun SlotGridLayout(
    config: All,
    bookings: List<All>,
    slotMode: String,
    selectedDate: String,
    selectedStandort: String,
    selectedCell: All?,
    editMode: Boolean,
    onCellClick: (All, All?) -> Unit,
    onCellToggleDisabled: ((All) -> Unit)?,
    onCellDoubleClick: (All, All?) -> Unit,
    onBookingHover: ((All, Double, Double) -> Unit)? = null,
    onBookingHoverEnd: (() -> Unit)? = null
) {
    val windows = slotTimeWindows(config).filter { window ->
        slotMode != SLOT_VIEW_SETUP || slotIsSetupWindowVisible(config, selectedDate, window)
    }
    if (windows.isEmpty()) return
    val unifiedRows = slotUnifiedRows(config)
    val slotColumnWidthPx = 58
    val timeColumnWidthPx = 360
    val totalWidthPx = slotColumnWidthPx + (windows.size * timeColumnWidthPx)

    Div({ classes(SlotStyles.gridWrapper) }) {
        Div({ classes(SlotStyles.gridScroll) }) {
            Div({
                style {
                    width(totalWidthPx.px)
                    minWidth(totalWidthPx.px)
                    display(DisplayStyle.Flex)
                    flexDirection(FlexDirection.Column)
                }
            }) {
                Div({
                    classes(SlotStyles.tableGrid, SlotStyles.stickyHeaderRow)
                    style {
                        display(DisplayStyle.Grid)
                        property("grid-template-columns", "${slotColumnWidthPx}px repeat(${windows.size}, ${timeColumnWidthPx}px)")
                    }
                }) {
                    Div({
                        classes(SlotStyles.tableHeaderCell)
                        style {
                            left(0.px)
                            property("z-index", "13")
                            position(Position.Sticky)
                        }
                    }) {
                        org.jetbrains.compose.web.dom.Span({ classes(SlotStyles.tableHeaderLabel) }) {
                            org.jetbrains.compose.web.dom.Text("Slot")
                        }
                    }
                    windows.forEach { window -> GridHeaderCell(slotTimeAxisLabel(window.uhrzeitVon)) }
                }

                Div({
                    classes(SlotStyles.tableGrid)
                    style {
                        display(DisplayStyle.Grid)
                        property("grid-template-columns", "${slotColumnWidthPx}px repeat(${windows.size}, ${timeColumnWidthPx}px)")
                    }
                }) {
                    unifiedRows.forEach { row ->
                        GridHeaderValue(row.lfdNr.toString())
                        windows.forEach { timeWindow ->
                            val disabledByConfig = slotIsCellDisabled(config, row.lfdNr, timeWindow)
                            val disabledBySetupWindow = slotMode == SLOT_VIEW_SETUP &&
                                !slotIsSetupCellBookable(config, selectedDate, timeWindow)
                            val disabled = disabledByConfig || disabledBySetupWindow
                            val booking = slotBookingForCell(
                                bookings = bookings,
                                config = config,
                                datum = selectedDate,
                                slotIndex = row.lfdNr,
                                timeWindow = timeWindow,
                                standort = selectedStandort
                            )
                            val cell = slotCellSelection(
                                datum = selectedDate,
                                slotIndex = row.lfdNr,
                                timeWindow = timeWindow,
                                standort = selectedStandort,
                                booking = booking
                            )
                            val clickable = slotIsClickable(booking, disabled)
                            val cellState = slotCellState(booking, disabled)
                            SlotGridCell(
                                booking = booking,
                                disabled = disabled,
                                cellState = cellState,
                                clickable = clickable,
                                editMode = editMode,
                                selected = slotSameCell(selectedCell, cell),
                                onClick = {
                                    if (editMode) onCellToggleDisabled?.invoke(cell)
                                    else if (clickable) onCellClick(cell, booking)
                                },
                                onDoubleClick = {
                                    if (!editMode && clickable) onCellDoubleClick(cell, booking)
                                },
                                onHover = { event ->
                                    if (!editMode && booking != null && clickable) {
                                        onBookingHover?.invoke(
                                            booking,
                                            event.clientX.toDouble(),
                                            event.clientY.toDouble()
                                        )
                                    }
                                },
                                onHoverEnd = {
                                    if (!editMode) onBookingHoverEnd?.invoke()
                                }
                            )
                        }
                    }
                }
            }
        }
    }
}

@Composable
private fun SlotGridCell(
    booking: All?,
    disabled: Boolean,
    cellState: Int,
    clickable: Boolean,
    editMode: Boolean,
    selected: Boolean,
    onClick: () -> Unit,
    onDoubleClick: () -> Unit,
    onHover: (MouseEvent) -> Unit,
    onHoverEnd: () -> Unit
) {
    Div({
        classes(SlotStyles.slotCell)
        onClick { onClick() }
        onDoubleClick { onDoubleClick() }
        onMouseEnter { event ->
            val mouseEvent = event.nativeEvent as? MouseEvent ?: return@onMouseEnter
            onHover(mouseEvent)
        }
        onMouseMove { event ->
            val mouseEvent = event.nativeEvent as? MouseEvent ?: return@onMouseMove
            onHover(mouseEvent)
        }
        onMouseLeave { onHoverEnd() }
        style { cursor(if ((!clickable || disabled) && !editMode) "default" else "pointer") }
    }) {
        Div({
            classes(SlotStyles.slotCellCard)
            if (disabled) classes(SlotStyles.slotCellDisabled)
            if (editMode) classes(SlotStyles.slotCellEditable)
            if (booking != null && cellState != org.example.project.service.ZustandManager.Slot.FREI) {
                classes(SlotStyles.slotCellActive)
            }
            if (cellState == org.example.project.service.ZustandManager.Slot.IN_BUCHUNG) {
                classes(SlotStyles.slotCellInBooking)
            }
            if (selected) classes(SlotStyles.slotCellSelected)
        }) {
            if (booking != null) {
                SlotBookingCardContent(booking)
            }
        }
    }
}
